<template>
  <panel
    :on-hide="onHide"
    :store="store"
    title="Subscribe"
  >
    <template slot="footer">
      <a
        v-if="hideItems"
        :href="`${store.state.episode.episode_url}?subscribe=true`"
        class="subscribe-tools"
        target="simplecast-share"
        title="More Subscribe Options"
        @click="store.sendShareSubscribeEvent('share', ' CLICK', 'share')"
      >More Options <icon-open /></a>
    </template>
    <ul class="subscribe-links">
      <li
        v-for="channel in channelsFiltered"
        :key="channel.title">
        <a
          :href="getChannelUrl(channel.title)"
          :title="channel.title"
          target="simplecast"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', channel.title)">
          <component
            v-if="isDark && channel.darkIcon"
            :is="channel.darkIcon" />
          <component
            v-else
            :is="channel.icon" />
        </a>
      </li>
      <li v-if="rssUrl">
        <a
          :href="rssUrl"
          target="simplecast"
          title="RSS Link"
          @click="store.sendShareSubscribeEvent('subscribe', 'SUBSCRIBE', 'RSS Link')"
        ><IconRss /></a>
      </li>
    </ul>
  </panel>
</template>

<script>
import Panel from './Panel'
import IconRss from '../assets/svg/rss.svg'
import Breaker from '../assets/svg/breaker.svg'
import GooglePodcasts from '../assets/svg/google-podcasts.svg'
import IconApplePodcasts from '../assets/svg/apple-podcasts.svg'
import Iheart from '../assets/svg/iheart.svg'
import Overcast from '../assets/svg/overcast.svg'
import Pandora from '../assets/svg/pandora.svg'
import PocketCasts from '../assets/svg/pocket-casts.svg'
import RadioPublic from '../assets/svg/radiopublic.svg'
import Spotify from '../assets/svg/spotify.svg'
import Stitcher from '../assets/svg/stitcher.svg'
import TuneIn from '../assets/svg/tune-in.svg'
import Deezer from '../assets/svg/deezer.svg'
import Radio from '../assets/svg/radio-dark.svg'
import RadioDarkMode from '../assets/svg/radio-light.svg'
import IconOpen from '../assets/svg/open.svg'
import Amazon from '../assets/svg/amazon-podcasts.svg'
import AmazonDark from '../assets/svg/amazon-dark-podcasts.svg'
import Gaana from '../assets/svg/gaana-podcasts.svg'
import Jiosaavn from '../assets/svg/jiosaavn-podcasts.svg'
import JiosaavnDark from '../assets/svg/jiosaavn-dark-podcasts.svg'
import PlayerFm from '../assets/svg/playerfm-podcasts.svg'

export default {
  components: {
    Panel,
    IconOpen,
    IconRss
  },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  data () {
    return {
      channels: [
        {
          title: 'Apple Podcasts',
          icon: IconApplePodcasts
        },
        {
          title: 'Spotify',
          icon: Spotify
        },
        {
          title: 'Google Podcasts',
          icon: GooglePodcasts
        },
        {
          title: 'Amazon Music and Audible',
          icon: Amazon,
          darkIcon: AmazonDark
        },
        {
          title: 'Pandora',
          icon: Pandora
        },
        {
          title: 'Stitcher',
          icon: Stitcher
        },
        {
          title: 'iHeartRadio',
          icon: Iheart
        },
        {
          title: 'Radio.com',
          icon: Radio,
          darkIcon: RadioDarkMode
        },
        {
          title: 'Deezer',
          icon: Deezer
        },
        {
          title: 'Overcast',
          icon: Overcast
        },
        {
          title: 'Pocketcast',
          icon: PocketCasts
        },
        {
          title: 'PlayerFM',
          icon: PlayerFm
        },
        {
          title: 'RadioPublic',
          icon: RadioPublic
        },
        {
          title: 'Breaker',
          icon: Breaker
        },
        {
          title: 'Tune In',
          icon: TuneIn
        },
        {
          title: 'Gaana',
          icon: Gaana
        },
        {
          title: 'JioSaavn',
          icon: Jiosaavn,
          darkIcon: JiosaavnDark
        }
      ]
    }
  },
  computed: {
    channelsFiltered () {
      return this.channels.filter(channel => this.getChannelUrl(channel.title))
    },
    hideItems () {
      return this.store.state.distributionChannels.length > 8 && !window.getUrlParameter('show')
    },
    isDark () { return this.store.state.isDark },
    episodeUrl () {
      return this.store.state.episode.custom_url && this.store.state.episode.custom_url !== '' ? this.store.state.episode.custom_url : this.store.state.episode.episode_url
    },
    itunesUrl () {
      if (this.store.state.podcast.itunes_url && this.store.state.podcast.itunes_url !== '') {
        return this.store.state.podcast.itunes_url
      }

      return false
    },
    rssUrl () {
      if (this.store.state.podcast.external_feed_url && this.store.state.podcast.external_feed_url !== '') {
        return this.store.state.podcast.external_feed_url
      }
      if (this.store.state.podcast.feed_url && this.store.state.podcast.feed_url !== '') {
        return this.store.state.podcast.feed_url
      }

      return false
    },
    size () { return this.store.state.size }
  },
  methods: {
    onHide () {
      this.store.setShowSubscribe(false)
    },
    getChannelUrl (name) {
      let c = this.store.state.distributionChannels && this.store.state.distributionChannels.find(channel => {
        if (channel.distribution_channel) return channel.distribution_channel.name === name

        return channel.name === name
      })
      return c && c.url
    }
  }
}
</script>

<style lang="scss">
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';
@import 'node_modules/simplecast-styles/src/assets/styles/_core/fonts.scss';

.subscribe-links{
  display: block;
  flex-wrap: wrap;
  margin: 0;
  list-style: none;
  padding: 0;
  margin: -6px -16px;

  li {
    padding: 6px 16px;
    display: inline-block;
    svg {
      height: 24px;
      width: 24px;
    }
  }
}
.subscribe-tools {
  display: none;
}

.panel-small {
  .subscribe-tools {
    display: inline-flex;
    text-decoration: none;
    font-family: RobotoMono-Regular;
    font-size: 12px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    align-items: center;
    svg {
      order: -1;
      margin-right: 8px;
    }
  }
  .smHide {
    display: none;
  }
  .subscribe-links {
    li {
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
}
.panel-smallest {
  .subscribe-links {
    margin: -3px -8px;
    li {
      padding: 3px 8px;
      svg {
        height: 24px;
        width: 24px;
      }
    }
  }
}
</style>
